// PricingConfiguration.js - Main entry point for Pricing Configuration
// This component renders the tabbed interface for managing all pricing-related data
import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';

// Import all tab components
import PriceTablesTab from './PriceTablesTab';
import LookupTablesTab from './LookupTablesTab';
import Lookup2DTablesTab from './Lookup2DTablesTab';
import ColorCategoriesTab from './ColorCategoriesTab';
import ColorRulesTab from './ColorRulesTab';
import SurchargesTab from './SurchargesTab';
import FormulaRulesTab from './FormulaRulesTab';
import PricingRulesTab from './PricingRulesTab';
import AttributeLabelsTab from './AttributeLabelsTab';

const TAB_NAMES = ['tables', 'lookups1d', 'lookups2d', 'colorcategories', 'colorrules', 'surcharges', 'formulas', 'rules', 'labels'];

const PricingConfiguration = ({ initialTab = '', highlightRule = '' }) => {
  const initialIndex = initialTab ? Math.max(TAB_NAMES.indexOf(initialTab), 0) : 0;
  const [activeTab, setActiveTab] = useState(initialIndex);

  const tabs = [
    { label: 'Price Tables',      component: <PriceTablesTab /> },
    { label: 'Lookups (1D)',      component: <LookupTablesTab /> },
    { label: 'Lookups (2D)',      component: <Lookup2DTablesTab /> },
    { label: 'Color Categories',  component: <ColorCategoriesTab /> },
    { label: 'Color Rules',       component: <ColorRulesTab /> },
    { label: 'Surcharges',        component: <SurchargesTab /> },
    { label: 'Formulas',          component: <FormulaRulesTab highlightRule={highlightRule} /> },
    { label: 'Pricing Rules',     component: <PricingRulesTab highlightRule={highlightRule} /> },
    { label: 'Attribute Labels',  component: <AttributeLabelsTab /> },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Pricing Configuration</Typography>

      <Paper sx={{ mb: 2, p: 1.5, bgcolor: '#e3f2fd' }}>
        <Typography variant="body2">
          Configure pricing rules for windows and doors. Changes here affect how quotes are calculated.
          The pricing system uses tables, lookups, and formulas to determine final prices based on
          window type, size, colors, glass options, grills, and other attributes.
        </Typography>
      </Paper>

      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2 }}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>

      {tabs[activeTab]?.component}
    </Box>
  );
};

export default PricingConfiguration;
